export const isTwrKeyfob = (txid: string): boolean => txid.slice(0, 1) === 'F'
